export default __webpack_public_path__ + "static/media/nft8.fbc9e476.jpeg";